module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/error-a1daf3ca5923e27e32070d35b690536d.svg";